// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'objektiv', 'objektiv Fallback', Objektiv, sans-serif"},"className":"__className_5a7e50","variable":"__variable_5a7e50"};